import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Toolbar from '@mui/material/Toolbar';

const StyledToolbar = styled(Toolbar)`
  padding: 0 ${props => props.theme.spacing(3)};

  ${props => props.theme.breakpoints.down('lg')} {
    padding: 0 ${props => props.theme.spacing(2)};
  }
  
  ${ComponentStyles}
`;

StyledToolbar.propTypes = {
  theme: PropTypes.object
};

export default StyledToolbar;
